import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useEditEmployeePageHeader } from '@pages/Employees/EditEmployee/hooks';

export const EditEmployeePageHeader = () => {
  const { employeeId, isPortfolioTab, openAddImageModal } =
    useEditEmployeePageHeader();

  if (!employeeId || !isPortfolioTab) {
    return null;
  }

  return (
    <Button type="primary" icon={<PlusOutlined />} onClick={openAddImageModal}>
      Добавить изображение
    </Button>
  );
};
